document.querySelectorAll('.product-variants .product-variants__list li > a').forEach(function(element) {
    element.addEventListener('mouseup', function() {
    window.localStorage.setItem(
    this.getAttribute('href'),
    JSON.stringify([ document.querySelector('#uncomplicated-category-breadcrumb-final-item').textContent,document.querySelector('#uncomplicated-category-breadcrumb-final-item').getAttribute('href')])
    );
    });
    });


const lastSegment = window.location.href.split("/").pop();
if (localStorage.getItem("/products/"+lastSegment) != null) {
    const collection = JSON.parse(window.localStorage.getItem("/products/"+lastSegment));
    document.querySelector('#uncomplicated-breadcrumbs #uncomplicated-category-breadcrumb-final-item').innerHTML = collection[0].replace(`\\u0026`,"&");
    document.querySelector('#uncomplicated-breadcrumbs #uncomplicated-category-breadcrumb-final-item').setAttribute('href',collection[1]);
}

document.addEventListener('theme:product:DOMContentLoaded', () => {
    setTimeout(() => {
        document.getElementById('breadcrumb-mobile').innerHTML = document.getElementById('breadcrumb-desktop').innerHTML;
    }, 1000)
})